import React from 'react';
import {Payments} from '../Payments';

export const MasterAccountPayments: React.FC<any> = ({masterAccountId}) => {
  return <Payments accountId={masterAccountId} isMasterAccount={true} />;
};
